export const SHADOW_OPACITY = 0.24;
export const MIN_WIDTH_BAR_LEFT = 110;
export const MIN_WIDTH_BAR_RIGHT = 40;
